<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: "MainMenu",
};
</script>